import _ from "lodash";
import { useRef, useEffect } from "react";

export const useLatestState = ({ states }) => {
  const statesRef = useRef({ ...states });

  useEffect(() => {
    _.assign(statesRef.current, states);
  }, [states]);

  return statesRef;
};
